import classNames from 'classnames';

import { addNewProduct } from '@urls';
import { getClientLang, Languages } from '@utils/i18n';
import { Link } from '@ui/Link';
import { Image } from '@ui/Image';

import bannerHorizontalRu from './images/banner-horizontal@ru.png';
import bannerHorizontalUk from './images/banner-horizontal@uk.png';
import bannerVerticalRu from './images/banner-vertical@ru.png';
import bannerVerticalUk from './images/banner-vertical@uk.png';

import s from './ProductDetailsStartSellingBanner.sss';

interface Props {
  className?: string,
}

export const ProductDetailsStartSellingBanner: React.FC<Props> = ({
  className,
}) => {
  const lang = getClientLang();

  return (
    <div className={classNames(s.root, className)}>
      <Link
        className={s.holder}
        theme='clean'
        to={addNewProduct}
      >
        <Image
          className={classNames(s.image, s.imageTypeMobile)}
          src={lang === Languages.uk ? bannerHorizontalUk : bannerHorizontalRu}
          lazy={true}
          alt='banner'
        />

        <Image
          className={classNames(s.image, s.imageTypeDesktop)}
          src={lang === Languages.uk ? bannerVerticalUk : bannerVerticalRu}
          lazy={true}
          alt='banner'
        />
      </Link>
    </div>
  );
};
